import { mergeQueryKeys } from '@lukemorales/query-key-factory';
import { translates } from './translates';
import { conversations } from './conversations';
import { qaPair } from './qaPair';
import { stores } from './stores';
import { departments } from './departments';
import { accounts } from './accounts';
import { dashboards } from './dashboards';
import { notices } from './notices';
import { bootstraps } from './bootstraps';
import { orders } from './orders';
import { products } from './products';
import { coupons } from './coupons';
import { tickets } from './tickets';
import { pureLLM } from './pureLLM';
import { jolectBuyerCenterQueries } from './jolectBuyerCenter';

export const queries = mergeQueryKeys(
  translates,
  conversations,
  qaPair,
  stores,
  departments,
  accounts,
  dashboards,
  notices,
  bootstraps,
  orders,
  products,
  coupons,
  tickets,
  pureLLM,
  jolectBuyerCenterQueries,
);
